import { SELECT_COLOR, CLEAR_SQUARES, SELECT_MODELE } from "../actions";
import { LEFT } from "../components/config";

const initialState = "#FFFFFF";

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SELECT_COLOR:
            return payload;
        case SELECT_MODELE:
        case CLEAR_SQUARES:
            return initialState;
        default:
            return state;
    }
};
